import { render } from "./NewInventory.vue?vue&type=template&id=c0071400&scoped=true"
import script from "./NewInventory.vue?vue&type=script&lang=js"
export * from "./NewInventory.vue?vue&type=script&lang=js"

import "./NewInventory.vue?vue&type=style&index=0&id=c0071400&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0071400"]])

export default __exports__